import { ROUTES } from '@/app/lib/constants'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import { Typography } from '@mui/material'

import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { useEffect } from 'react'
import { useIntersectionObserver } from 'usehooks-ts'
import { useSearchInputContext } from '../../course/contexts/InputSearchContext'
import { ImageWithFallback } from '../../shared/components/image-with-fallback'
import { AvailableLanguages } from '../../shared/providers/LanguageSelectionProvider'

type TaxonomyPageHeaderProps = {
  taxonomy: {
    name: string
    slug: string
    description?: string
  }
  locale: AvailableLanguages
}

export function TaxonomyPageHeader({
  taxonomy,
  locale,
}: TaxonomyPageHeaderProps) {
  const t = useTranslations('CategoryPage')

  const { isIntersecting: isVisible, ref } = useIntersectionObserver({
    initialIsIntersecting: true,
  })

  const { setIsLargeSearchVisible } = useSearchInputContext()

  useEffect(() => {
    setIsLargeSearchVisible(isVisible)
  }, [isVisible, setIsLargeSearchVisible])

  return (
    <div className="relative min-h-72 py-14" ref={ref}>
      <div className="absolute inset-0">
        <div
          style={{
            background: `linear-gradient(0deg, rgba(207, 185, 254, 0.20) 0%, rgba(17, 17, 17, 0.00) 166.06%)`,
          }}
          className="absolute inset-0 z-10"
        ></div>
        <ImageWithFallback
          alt={taxonomy.name}
          src={`/images/taxonomy-images/banner-${taxonomy.slug}.jpg`}
          fallbackSrc="/images/taxonomy-images/banner-fallback.jpg"
          width={3000}
          height={1327}
          className="absolute z-0 h-full w-full bg-mydra-black object-cover"
        />
      </div>
      <div className="container relative z-10 flex flex-col gap-2">
        <Link
          href={{
            pathname: ROUTES.homepage,
          }}
          locale={locale}
        >
          <div className="flex items-center text-white">
            <KeyboardArrowLeftIcon />
            <Typography className="text-white">{t('all_courses')}</Typography>
          </div>
        </Link>
        <Typography variant="h1" className="text-white">
          {taxonomy.name}
        </Typography>

        {taxonomy.description && (
          <Typography variant="subtitle3" className="text-white">
            {taxonomy.description}
          </Typography>
        )}
      </div>
    </div>
  )
}
